import { useEffect, useState } from 'react'

/**
 * Counts down from `intervalSeconds` and resets when it hits 0.
 * Returns the current seconds remaining.
 */
export const useRefreshCountdown = (intervalSeconds: number): number => {
  const [secondsLeft, setSecondsLeft] = useState(intervalSeconds)

  useEffect(() => {
    const timer = setInterval(() => {
      setSecondsLeft((prev) => (prev <= 1 ? intervalSeconds : prev - 1))
    }, 1000)
    return () => clearInterval(timer)
  }, [intervalSeconds])

  return secondsLeft
}
